import emoji from 'react-easy-emoji';

const greeting = {
    username: "Pravesh Bansal",
    title: "Hey there! I'm Pravesh",
    subTitle: emoji(
        "Full Stack Developer 👨‍💻 | Student 🤖 | Chitkara University 🎓"
    )
}

const socialMeadia = {

}

const aboutSection = {
    title: "  About Me",
    education: "Education",
    universityName: "  Chitkara University",
    universityDuration: " 2019-Present",
    school: "Schooling",
    schoolName: "   All Saint's School",
    schoolDuration: "  2017-2019 (Higher secondary)",
    aboutPara1: "I am a Computer Science Engineering student pursing BTech from Chitkara University, Punjab. I am always excited to know about the new market technologies which I can learn and implement at my level.",
    aboutPara2: "I always try to find and store the new challenging things in my mind which is helpful and fruitful for my further studies and my upcoming carrer. I am a keen learner and always be ready to the learn new things and give my best.",
}

const skillsSection = {
    title: "What i do",
    subTitle:
        "CURRENTLY STUDYING IN CHITKARA UNIVERSITY AND EXPLORING COMPUTER SCIENCE",
    skills: [
        emoji(
            "⚡ Learning data structures and algorithms and the programming languages"
        ),
        emoji("⚡ Learning FullStack Development"),
        
        emoji(
            "⚡ Building predictive models to extract insights and make decisions out of data"
        ),
    ],

    softwareSkills: [
        {
            skillName: "HTML",
            classname: "logos:html-5",
            style: {
                backgroundColor: "transparent",
            },
        },
        {
            skillName: "CSS",
            classname: "logos:css-3",
            style: {
                backgroundColor: "transparent",
            },
        },
        {
            skillName: "C",
            classname: "logos:c",
            style: {
                backgroundColor: "transparent",
            },
        },
        {
            skillName: "java",
            classname: "logos:java",
            style: {
                backgroundColor: "transparent",
            },
        },
        {
            skillName: "reactJS",
            classname: "simple-icons:react",
            style: {
                color: "#61DAFB",
            },
        },
        {
            skillName: "git",
            classname: "logos:git-icon",
            style: {
                backgroundColor: "transparent",
            },
        },
        {
            skillName: "JavaScript",
            classname: "logos:javascript",
            style: {
                backgroundColor: "transparent",
            },
        },
        {
            skillName: "GitHub",
            classname: "logos:github-icon",
            style: {
                backgroundColor: "transparent",
            },
        }
    ],
};
const contactSection = {
    tittle: " QUERIES",
    phone: " CALL US",
    home: " Location",
    email: "bansalpravesh2@gmail.com",
    num: "8239556333",
    add: "Rajasthan, India"
}
const footerText = {
    subTitle: emoji(
        "Made with ❤ by Pravesh Bansal"
    )
}


export default greeting;
export { aboutSection, skillsSection, contactSection, footerText };